import type { DesignBuilding } from 'src/modules/designStudio/helpers/data/TemplateDesignConfig';

// A reference to the current machete building. This is the equivalent
// of React creatRef except current is not readonly. This reference is required
// to provide clean access to the current machete building regardless of scope
// (e.g. in a xstate machine or in react)
export const macheteBuildingRef: { current: null | DesignBuilding } = {
  current: null,
};
